module.exports = __webpack_public_path__ + "4a5daf759886def008fd2065c1a83db0.png";